module.exports = __webpack_public_path__ + "img/img2.be38e592.jpeg";